import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { MediaBreakPointUp } from '@lean-body/components/styles';
import { CountLessonCard } from '../molecules/count_lesson_card';
import { ITEMS_PADDING_RIGHT_AND_LEFT_SP, ITEM_WIDTH_SP } from '../molecules/vertical_list_arrows';
import 'swiper/css';
import 'swiper/css/autoplay';
const ITEM_MARGIN = 10;
// 見つける欄の左右余白。レッスンのスライド幅は、Swiper幅からこの余白を引いた値になる
const SIDE_MARGIN_SP = 20;
const SIDE_MARGIN_MD = 24;
const SIDE_MARGIN_PC = 32;
const lessonSlideWidth = (sideMargin) => ITEM_WIDTH_SP + ITEMS_PADDING_RIGHT_AND_LEFT_SP - sideMargin * 2;
// スマホ・iPadそれぞれ、レッスン動画2枚と、そのあいだの余白と同じ幅
const ITEM_WIDTH_PHONE = lessonSlideWidth(SIDE_MARGIN_SP) * 2 + ITEM_MARGIN;
const ITEM_WIDTH_IPAD = lessonSlideWidth(SIDE_MARGIN_MD) * 2 + ITEM_MARGIN;
// PCは変更前のカード幅
const ITEM_WIDTH_PC = 335;
const AUTOPLAY_DELAY_MS = 3000;
// ループが成立するようにスライドを繰り返して確保する最低数(画面幅が広い場合の表示枚数を考慮)
const MIN_SLIDES_FOR_LOOP = 8;
// 開始位置は他の項目に揃え、スライド中のカードは左右の表示領域端まで見せる。
export const CountLessonCarousel = ({ lessons, onClickLesson, classObject }) => {
    // 最初に左端へ出すレッスンはランダムに選ぶ(マウント時に1度だけ決める)
    const [initialSlide] = React.useState(() => Math.floor(Math.random() * lessons.length));
    const [hasStartedSliding, setHasStartedSliding] = React.useState(false);
    const onBeforeTransitionStart = (_swiper, speed) => {
        // 初期位置の設定やループの並べ替え(speed=0)では、左端の表示をまだ開放しない。
        if (speed > 0)
            setHasStartedSliding(true);
    };
    // ループモードはスライド数が表示枚数より多くないと成立しないため、レッスンを繰り返して埋める
    const slides = [];
    while (slides.length < MIN_SLIDES_FOR_LOOP) {
        slides.push(...lessons);
    }
    return (React.createElement(Swiper, { className: css(styles.carousel, !hasStartedSliding && styles.initialSwiper, classObject), modules: [Autoplay], slidesPerView: "auto", loop: true, initialSlide: initialSlide, spaceBetween: ITEM_MARGIN, autoplay: { delay: AUTOPLAY_DELAY_MS, disableOnInteraction: false, pauseOnMouseEnter: true }, onSliderFirstMove: () => setHasStartedSliding(true), onBeforeTransitionStart: onBeforeTransitionStart }, slides.map((lesson, i) => (React.createElement(SwiperSlide, { key: i, className: css(styles.slide) },
        React.createElement(CountLessonCard, { lesson: lesson, classObject: styles.card, onClick: () => onClickLesson(lesson.id) }))))));
};
const styles = StyleSheet.create({
    // swiperで始まるクラス名はSwiper内部に保持されるため、初期クリップを切り替えるスタイルには使わない。
    carousel: {
        width: '100%',
        // 余白をSwiper自身に持たせ、左の余白部分でも移動中のカードをクリップしない。
        paddingLeft: SIDE_MARGIN_SP,
        [MediaBreakPointUp.MD]: {
            paddingLeft: SIDE_MARGIN_MD,
        },
        [MediaBreakPointUp.XL]: {
            paddingLeft: SIDE_MARGIN_PC,
        },
    },
    // 最初だけループ用の前のカードを隠す。スライド開始後は左の余白部分にもカードを表示する。
    initialSwiper: {
        clipPath: `inset(0 0 0 ${SIDE_MARGIN_SP}px)`,
        [MediaBreakPointUp.MD]: {
            clipPath: `inset(0 0 0 ${SIDE_MARGIN_MD}px)`,
        },
        [MediaBreakPointUp.XL]: {
            clipPath: `inset(0 0 0 ${SIDE_MARGIN_PC}px)`,
        },
    },
    slide: {
        width: ITEM_WIDTH_PHONE,
        cursor: 'pointer',
        [MediaBreakPointUp.MD]: {
            width: ITEM_WIDTH_IPAD,
        },
        [MediaBreakPointUp.XL]: {
            width: ITEM_WIDTH_PC,
        },
    },
    // カルーセル内ではスライド幅に合わせて固定する
    card: {
        width: ITEM_WIDTH_PHONE,
        maxWidth: 'none',
        [MediaBreakPointUp.MD]: {
            width: ITEM_WIDTH_IPAD,
        },
        [MediaBreakPointUp.XL]: {
            width: ITEM_WIDTH_PC,
        },
    },
});
